// extracted by mini-css-extract-plugin
export default {"header":"UserPage_header__5p9pN","select":"UserPage_select__ZV3k8"};